export const DECLINE_STATUS_REGEX = new RegExp(/^3.*$/);
export const UNDER_REVIEW_STATUS_REGEX = new RegExp(/^[469].*$/);
export const FINAL_STATUS_REGEX = new RegExp(/^(?:10.*|509|510)$/);
export const CONDITIONAL_APPROVE_STATUS_REGEX = new RegExp(/^5(?!09$|10$).*/);
export const FUNDED_STATUS_REGEX = new RegExp(/^(?:11|12|8).*/);
export const CLOSED_STATUS_REGEX = new RegExp(/^7.*$/);

export const LESS_THAN_THOUSAND_CHAR_REGEX = new RegExp(/^.{0,1000}/);
